import { AlterSituacaoEnum, PerfilRestrictEnumEPC, SituacaoRestrictEnumEPC, Situacao2RestrictEnumEPC, TipoMensagem, CabecalhoMensagens, MensagensPadrao } from "../enums/Enumarations";
import { BaseImplemantation } from './base-system-implementation';

/**
 * Implementação da Interface sistema para o sistema EPC para restrição de acesso ao usuário.
 */
export class EpcImplementation extends BaseImplemantation {

    situacaoAlter: any = AlterSituacaoEnum;
    perfilRestrict: any = PerfilRestrictEnumEPC;
    situacaoRestric: any = SituacaoRestrictEnumEPC;
    variableComparable: any = Situacao2RestrictEnumEPC;

    dataTableFunction(event?: any, controllerName?: any, filtro?: any, situacao?: any, listagem?: any,
        value6?: any, value7?: any, value8?: any, value9?: any, value10?: any) {
        let homologacao_curso: any;

        switch (event.button) {
            case 'enviar_cadastro':
                if (situacao != this.variableComparable['Iniciado']) {
                    this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], MensagensPadrao[14]);
                    return;
                } else if (situacao != this.variableComparable['Iniciado'] && this.perfilRestrict[0]) {
                    this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], MensagensPadrao[15]);
                    return;
                } else {
                    this.router.navigate(['./enviar-cadastro', event.selection['id']], { relativeTo: this.activatedRoute });
                }
                break;
            case 'alterar_responsavel':
                this.router.navigate(['./alterar-responsavel', event.selection['id']], { relativeTo: this.activatedRoute });
                break;
            case 'abrir_lancamento':
                this.router.navigate(['./boleto', event.selection['id']], { relativeTo: this.activatedRoute });
                break;
            case 'curso-turma':
                this.router.navigate(['/atividades/curso-prestacao-conta/listar-turma', event.selection['id']], { relativeTo: this.activatedRoute });
                break;
            case 'turma_prestar_conta':
                this.router.navigate(['/atividades/turma/prestar-conta', event.selection['id']], { relativeTo: this.activatedRoute });
                break;
            case 'turma_editar':
                this.router.navigate(['/atividades/turma/editar', event.selection['id']], { relativeTo: this.activatedRoute });
                break;
            case 'enviar_cadastro_curso':
                if (this.variableComparable[situacao] !== null) {
                    this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], MensagensPadrao[14]);
                    return;
                } else {
                    homologacao_curso.id_curso = event.selection['id'];
                    if (situacao == Situacao2RestrictEnumEPC["Aberto para recurso"])
                        homologacao_curso.id_perfil_receptor = 13;
                    else
                        homologacao_curso.id_perfil_receptor = 3;
                    this.confirmacao.confirm({
                        header: 'Confirmação',
                        message: `Deseja realmente enviar este registro?`,
                        accept: () => {
                            this.service.Atualizar(controllerName, {
                                id: event.selection['id'], id_situacao: situacao == Situacao2RestrictEnumEPC["Aberto para recurso"] ? 8 : 4
                            }, { parcial: "id_situacao" }).subscribe(
                                data => {
                                    listagem.refresh(filtro);
                                    this.showMsg(TipoMensagem[1], CabecalhoMensagens[2], MensagensPadrao[12]);
                                },
                                err => this.showMsg(TipoMensagem[4], CabecalhoMensagens[4], `${MensagensPadrao[13]} ${err}`)
                            );
                            this.service.Atualizar(controllerName + "/atualizaCursoHomologacao", homologacao_curso).subscribe(
                                data => { },
                            );
                        }
                    })
                }
                break;
            case 'turma_incluir':
                this.router.navigate(['/atividades/turma/turma-incluir', event.selection['id']], { relativeTo: this.activatedRoute });
                break;
            case 'enviar_cadastro_capacitadora':
                if (this.situacaoRestric[situacao] != undefined) {
                    this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], this.situacaoRestric[situacao]);
                    return;
                } else {
                    this.confirmacao.confirm({
                        header: 'Confirmação',
                        message: `Deseja realmente enviar este registro?`,
                        accept: () => {
                            this.service.Atualizar(controllerName + '/atualizarEnviarCadastro', event.selection['id']).subscribe(
                                data => {
                                    listagem.refresh(filtro);
                                    this.showMsg(TipoMensagem[1], CabecalhoMensagens[2], MensagensPadrao[12]);
                                },
                                err => this.showMsg(TipoMensagem[4], CabecalhoMensagens[4], `${MensagensPadrao[13]} ${err}`)
                            );
                        }
                    })
                }
                break;
            default:
                this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], MensagensPadrao[11]);
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/base/use-system/implementation-system/epc-system-implementation.ts